import { motion } from "framer-motion";
import { ArrowLeft, Newspaper, Download, Mail } from "lucide-react";
import { Button } from "../components/ui/button";
import { useNavigate } from "react-router-dom";
import { Card, CardContent } from "../components/ui/card";

export default function Press() {
  const navigate = useNavigate();
  
  const pressReleases = [
    {
      title: "YASNO Marketing Launches AI-Powered Voice Marketing Platform",
      date: "January 2026",
      excerpt: "Revolutionary platform enables businesses to manage marketing campaigns using voice commands."
    }
  ];
  
  return (
    <div className="min-h-screen bg-background py-12 px-4">
      <div className="max-w-4xl mx-auto">
        <Button 
          variant="ghost" 
          onClick={() => navigate(-1)}
          className="mb-6"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Back
        </Button>
        
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
        >
          <div className="flex items-center gap-3 mb-6">
            <Newspaper className="w-8 h-8 text-primary" />
            <h1 className="text-3xl font-bold">Press</h1>
          </div>
          
          <p className="text-muted-foreground mb-8">
            News, press releases, and media resources from YASNO Marketing.
          </p>
          
          {/* Media Contact */}
          <Card className="glass-card border-white/10 mb-8">
            <CardContent className="p-6">
              <h2 className="text-xl font-semibold mb-4">Media Contact</h2>
              <p className="text-muted-foreground mb-4">
                For press inquiries, interviews, or media resources, please contact our press team:
              </p>
              <div className="flex items-center gap-2">
                <Mail className="w-4 h-4 text-primary" />
                <a href="mailto:press@yasnomktg.com" className="text-primary hover:underline">
                  press@yasnomktg.com
                </a>
              </div>
            </CardContent>
          </Card>
          
          {/* Press Releases */}
          <h2 className="text-xl font-semibold mb-4">Press Releases</h2>
          <div className="space-y-4 mb-8">
            {pressReleases.map((release, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
              >
                <Card className="glass-card border-white/10 hover:border-primary/30 transition-all">
                  <CardContent className="p-6">
                    <span className="text-xs text-muted-foreground">{release.date}</span>
                    <h3 className="text-lg font-semibold mt-1 mb-2">{release.title}</h3>
                    <p className="text-muted-foreground">{release.excerpt}</p>
                  </CardContent>
                </Card>
              </motion.div>
            ))}
          </div>
          
          {/* Brand Assets */}
          <Card className="glass-card border-white/10">
            <CardContent className="p-6">
              <div className="flex items-center gap-3 mb-4">
                <Download className="w-5 h-5 text-primary" />
                <h2 className="text-xl font-semibold">Brand Assets</h2>
              </div>
              <p className="text-muted-foreground mb-4">
                Download our logo, brand guidelines, and other media assets for use in publications.
              </p>
              <Button variant="outline" onClick={() => window.location.href = 'mailto:press@yasnomktg.com?subject=Brand Assets Request'}>
                Request Brand Kit
              </Button>
            </CardContent>
          </Card>
          
          {/* Company Info */}
          <div className="mt-8 p-6 glass border border-white/10 rounded-xl">
            <h2 className="text-xl font-semibold mb-4">About YASNO Marketing</h2>
            <p className="text-muted-foreground">
              YASNO Marketing LLC is an AI-powered marketing platform that enables businesses to create, 
              manage, and publish marketing content across multiple social media platforms using voice 
              commands. Our multi-agent AI system handles everything from strategy to content creation 
              to publishing, revolutionizing how businesses approach digital marketing.
            </p>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
